import {NgZone} from '@angular/core';
import {fromEvent, Observable, Subscription} from 'rxjs';

export function fromEventOutsideAngularZone<T>(
    ngZone: NgZone,
    target: Element | Document,
    eventName: string,
    options?: EventListenerOptions
): Observable<T> {
    return new Observable(subscriber => {
        const subscription = new Subscription();

        ngZone.runOutsideAngular(() =>
            subscription.add(
                fromEvent<T>(target, eventName, options).subscribe(subscriber)
            )
        );

        return subscription;
    });
}
